import { render, staticRenderFns } from "./UpgradeModal.vue?vue&type=template&id=f87c83f8&scoped=true"
import script from "./UpgradeModal.vue?vue&type=script&lang=js"
export * from "./UpgradeModal.vue?vue&type=script&lang=js"
import style0 from "./UpgradeModal.vue?vue&type=style&index=0&id=f87c83f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87c83f8",
  null
  
)

export default component.exports